import { useEffect, useState } from "react"
import * as web3Service from "../blockchain/web3V2.service"
import { configs } from "../blockchain/web3V2.config"

export const useTokenMarketCap = () => {

  const [tokenMarketCap, setTokenMarketCap] = useState(0.0)
  const [isLoading, setLoading] = useState(false)


  useEffect(async () => {
    //get the main token address from config file
    const { web3Config } = configs
    const primaryTokenAddress = web3Config.contractWallets.main

    try {

      setLoading(true)
      //get the token main token price in usd
      const tokenMarketCapInUSD = await web3Service.getTokenMarketCapIUnUSDByTokenAddress(primaryTokenAddress)
      if (tokenMarketCapInUSD) {
        setTokenMarketCap(tokenMarketCapInUSD)
      } else {
        setTokenMarketCap(0.0)
      }
    } catch (error) {
      setTokenMarketCap(0.0)
      console.error('error while fetching token market cap ', error.message || '')
    } finally {
      setLoading(false)
    }

  }, [])


  return { tokenMarketCap, isLoading }
}

export default useTokenMarketCap

